import template from './leaveBenefitModal.html';
import controller from './leaveBenefitModal.controller';

let LeaveBenefitModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: "hmodal-info animated zoomIn"
};

export default LeaveBenefitModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/leaveBenefitModal/leaveBenefitModal.component.js